export const initHamburger = () => {
    const hamburger = document.querySelector('[data-hamburger]');
    if (!hamburger) return;
    const line = hamburger.querySelector('[data-hamburger-line]');
    const navMenu = document.querySelector('[data-menu]');
    const activeClass = 'active';
    const blurClass = 'menu-blur';

    hamburger.addEventListener('click', () => {
        const isActive = line.classList.toggle(activeClass);
        navMenu.classList.toggle(activeClass);

        if (isActive) {
            document.body.classList.add(blurClass);
        } else {
            document.body.classList.remove(blurClass);
        }
    });
};
